<template>
    <settings-wrapper title="Pool settings" section="Users">
        <v-card class="overflow-hidden">
            <v-tabs ref="tabs" color="primary" v-model="tab">
                <v-tab v-for="tab in tabs" :key="tab.tabName">
                    <v-icon left small>{{ tab.icon }}</v-icon>
                    {{ tab.tabName }}
                </v-tab>
            </v-tabs>
        </v-card>

        <v-tabs-items class="mt-7" v-model="tab">
            <v-tab-item v-for="tab in tabs" :key="tab.tabName">
                <component :is="tab.component"></component>
            </v-tab-item>
        </v-tabs-items>
    </settings-wrapper>
</template>

<script>
import { mapGetters } from 'vuex'
import SettingsWrapper from '@/components/SettingsWrapper.vue'

const PoolUsers = () => import('../components/PoolUsers.vue')
const PoolUserInvitations = () => import('../components/PoolUserInvitations.vue')

export default {
    name: 'PoolUserManagement',
    components: { PoolUsers, PoolUserInvitations, SettingsWrapper },
    data() {
        return {
            tab: null
        }
    },
    computed: {
        ...mapGetters('userStore', ['isResourcePoolManager']),
        tabs() {
            if (this.isResourcePoolManager) {
                return [
                    { tabName: 'Users', icon: 'mdi-account-group-outline', component: 'PoolUsers' },
                    { tabName: 'Invitations', icon: 'mdi-email-outline', component: 'PoolUserInvitations' }
                ]
            }

            return [{ tabName: 'Users', icon: 'mdi-account-group-outline', component: 'PoolUsers' }]
        }
    },
    watch: {
        tab() {
            setTimeout(() => {
                if (this.$refs.tabs && this.$refs.tabs.onResize) {
                    this.$refs.tabs.onResize()
                }
            }, 300)
        }
    }
}
</script>
